import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { result } from 'lodash';
import format from 'react-format-props';
import './style.scss';

export function NotificationIcon({ icon, isRead }) {
    const iconClass = classNames(['notification-icon', icon], { read: isRead });
    return <i className={iconClass} />;
}

NotificationIcon.propTypes = {
    icon: propTypes.string,
    isRead: propTypes.bool,
};

NotificationIcon.defaultProps = {
    icon: 'bell',
    isRead: false,
};

export default format(({ item }) => ({
    isRead: item.isRead,
    icon: result(item, 'msg_params.icon'),
}))(NotificationIcon);
